import React from 'react';
import { connect } from 'react-redux';
import {
  getLineItemsSubscribableQuantity,
  getNumOfSubscribableItemsReqToCheckout,
} from '../selectors';

import CheckoutButton from '../components/sidebar/CheckoutButton';

const mapStateToProps = state => ({
  lineItemsProcessing: state.lineItemsProcessing,
  isMembershipOrder: state.currentOrder.membership_order,
  itemQuantity: state.currentOrder.total_quantity,
  numOfSubscribableItemsReqToCheckout: getNumOfSubscribableItemsReqToCheckout(
    state
  ),
  hasViolations: state.currentOrder.violations.length > 0,
});

export default connect(mapStateToProps)(CheckoutButton);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/CheckoutButton.js